import ColorPicker from "./ColorPicker";
export { Color } from "./color";
export { default as ColorBlock } from "./components/ColorBlock";
export * from "./interface";
export default ColorPicker;